import { apiCall } from "./service";
import { URL_INDUSTRIES, URL_SEARCH_INDUSTRIES } from "./URL";

export const api = {
  getIndustriesRequest(params) {
    return apiCall.get({
      url: `${URL_INDUSTRIES}?loadAll=true`,
      isAuthToken: true,
    });
  },

  searchIndustriesRequest(searchTerm) {
    return apiCall.get({
      url: `${URL_SEARCH_INDUSTRIES}${searchTerm || ""}`,
      isAuthToken: true,
    });
  },

  createIndustryRequest(name) {
    return apiCall.post({
      url: `${URL_INDUSTRIES}`,
      isAuthToken: true,
      params: { name },
    });
  },

  getIndustryUsageRequest(id) {
    return apiCall.get({
      url: `${URL_INDUSTRIES}/${id}/usage`,
      isAuthToken: true,
    });
  },

  renameIndustryRequest(id, name) {
    return apiCall.put({
      url: `${URL_INDUSTRIES}/${id}`,
      isAuthToken: true,
      params: { name },
    });
  },

  deleteIndustryRequest(id) {
    return apiCall.delete({
      url: `${URL_INDUSTRIES}/${id}`,
      isAuthToken: true,
    });
  },
};

export default api;
